import ReactGA from 'react-ga4';
import Config from '../Config';

class Analytics {
  static init() {
    // Enable debug mode on the local development environment
    const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ReactGA.initialize(Config.GA4_ID, { debug: isDev })
  }
  
  static sendEvent(payload) {
    ReactGA.event(payload)
  }
  
  static sendPageview(path) {
    ReactGA.set({ page: path });
    ReactGA.send({ hitType: 'pageview', page: path, title: '' });
  }
}



export default Analytics;